import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, effect, ElementRef, HostBinding, HostListener, inject, Input, OnDestroy, OnInit, output, signal, viewChild, ViewChild } from '@angular/core';
import { ChatService } from '../chat.service';
import { UserService } from '../../services/user.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { CameraService } from '../../shared/image-uploader/camera/camera.service';
import { MatDialog } from '@angular/material/dialog';
import { Observable, take } from 'rxjs';
import { FirebaseService } from '../../services/firebase.service';
import { onChildChanged, onChildRemoved } from 'firebase/database';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChatInputComponent } from '../chat-input/chat-input.component';
import { WorkService } from '../../work/work.service';
import moment from 'moment';
import { FormBuilder, Validators } from '@angular/forms';
import { IndexedDBService } from '../../services/indexed-db.service';
import { App } from '@capacitor/app';
import { CameraComponent } from '../../shared/image-uploader/camera/camera.component';
import { PDFService } from '../../services/pdf.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltip } from '@angular/material/tooltip';
import { RoleService } from '../../role/role.service';

@Component({
  selector: 'app-chat-detail',
  standalone: false,
  templateUrl: './chat-detail.component.html',
  styleUrl: './chat-detail.component.scss'
})
export class ChatDetailComponent implements OnInit, AfterViewInit, OnDestroy {
  
  @Input() chat = null;
  @Input() compactChat = null;
  closed = output();
  updateWorks = output();
  
  
  chatService = inject(ChatService);

  roleService = inject(RoleService);

  userService = inject(UserService);
  
  workService = inject(WorkService);
  
  router = inject(Router);
  
  cdr = inject(ChangeDetectorRef);
  
  domSanitizer = inject(DomSanitizer);
  
  dialog = inject(MatDialog);
  
  camera = inject(CameraService);
  
  firebase = inject(FirebaseService);

  fullScreen = signal(false);
  
  destroyRef = inject(DestroyRef);
  
  fb = inject(FormBuilder);
  
  indexedDB = inject(IndexedDBService);

  pdfService = inject(PDFService);

  snackBar = inject(MatSnackBar);

  subscription = null;
  isKeyboardOpen = false;

  user = null;
  reply = null;
  event = null;
  document = null;
  threadSub = null;
  subscriptions: any[] = [];
  tempText = '';
  imagePreviews: any[] = [];
  messages: any[] = [];
  allMessages: any[] = [];
  threads:any[] = [];
  messagesPerPage = 20;
  page = 0;
  customWorks: any[] = [];
  ownWorks: any[] = [];

  budgets = signal<any[]>([]);

  events: any[] = [];


  currentWork = null;
  work = null;
  works = [];
  inputText = signal('');
  uploadingPhotos = signal(false);
  readingOldMessages = signal(false);
  loading = signal(false);
  agentWorking = signal(false);

  openBudgetForm = signal(false);

  budgetForm = this.fb.group({
    document_id: this.fb.control<number | null>(null),
    document_type: this.fb.control<string | null>(null),
    inventory_actions: this.fb.array([]),
  });

  eventForm = this.fb.group({
    id: [null],
    name: ['', Validators.required],
    start_date: ['', Validators.required],
    duration: ['', [Validators.required, Validators.min(1)]]
  });
  
  @ViewChild('fileChatInput') fileInput: ElementRef;
  @ViewChild('messagesContainer') messagesContainer: ElementRef;
  @ViewChild(ChatInputComponent) chatInput: ChatInputComponent;
  @HostBinding('class.thread') isThread = false;

  constructor(){
    this.userService.user$.subscribe((user) => {
      this.user = user;
    });
    effect(() => {
      if(this.chat && this.chat() && this.chat().id){
        this.isThread = this.chat().super_type === 'OpenAi::Thread';
        if(this.isThread){
          this.chatService.getAgentHistory().subscribe((threads) => {
            this.threads = threads;
            this.cdr.detectChanges();
          }
          , (error) => {
            console.error('Error fetching agent threads', error);
          }
          );
        }
        this.chatSubscribe();
        this.getChatComments();
      }
    });
  }

  ngOnInit() {
    if(this.compactChat){
      this.chat = signal(this.compactChat);
      this.indexedDB.read('chats', [
        this.compactChat.document_type,
        this.compactChat.document_id
      ], 'document').then((chats) => {
        if(chats && chats.length > 0){
          this.chat.set(chats[0]);
        }
      });
    }
    else{
      App.addListener('backButton', data => {
        this.goBack();
      });
      this.eventForm.valueChanges.subscribe((data) => {
        if(this.eventForm.valid){
          this.event = Object.assign(this.event, data);
        }
      });
    }
    
    this.subscription = this.chatService.keyboardOpen$.subscribe(open => {
      this.isKeyboardOpen = open;
      this.cdr.detectChanges();
    });
    
    this.chatService.newComments$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((comment) => {
      if (
          comment.commentable_id === this.chat().document_id &&
          comment.commentable_type === this.chat().document_type &&
          (
          (
            comment.target_id === this.user.id &&
            comment.target_type == 'User'
          ) || (
            comment.target_type !== 'User'
          )
      )) {
        const message = this.messages.find((msg) => msg.id === comment.id);
        if (!message) {
          this.messages.push(this.formatComment(comment,this.messages));
          this.allMessages.push(this.formatComment(comment,this.messages));
        }
        if(this.isThread){
          if(comment.author_type === 'Commentator::Kogu'){
            this.agentWorking.set(false);
          } 
        }
        this.cdr.detectChanges();
        if(!this.readingOldMessages()){
          this.read();
          this.scrollToBottom();
        }
      }
    });
    
  }

  ngAfterViewInit(): void {
    this.scrollToBottom();
  }

  getChatComments(load=true) {
    this.loading.set(load);
    if(load){
      this.allMessages = [];
      this.messages = [];
      this.works = [];
    }
    this.chatService.get(this.chat().id).subscribe({
      complete: () => {
        this.loading.set(false);
        this.cdr.detectChanges();
        this.scrollToBottom(true,load);
        this.getCustomWorks();
        this.read();
      },
      next: (data) => {
        

        this.allMessages = data.comments.map((comment) => this.formatComment(comment,data.comments)).sort((a, b) => {
          return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
        });
        if(load){
          this.messages = this.allMessages.slice(-this.messagesPerPage);
        }else{
          const total = this.allMessages.length;
          const end = total - this.messagesPerPage * this.page;
          const start = Math.max(0, end - this.messagesPerPage);
          this.messages = this.allMessages.slice(start, end);
        }
        this.works = data.current_works || [];
        this.events = data.events || [];
        this.budgets.set(data.budgets || []);
        for(let i = 0; i < this.page; i++){
          this.getPage(i);
        }
        this.getOwnWorks();
      }
    });
  }

  chatSubscribe() {
    this.subscriptions.forEach((sub) => {
      if (sub.unsubscribe) {
        sub.unsubscribe();
      }
    });
    this.subscriptions = [];
    if(this.isThread){
      const ref = `comments/${this.chat().document_type}-${this.chat().document_id}`
      this.subscriptions.push(this.firebase.subscribeToNew(ref, this.chat().readed_at,(comment) => {
        console.log('[FIREBASEDB] Message Added', comment);
        this.chatService.newComments$.next(comment);
      }
      , this.destroyRef));
    }
    this.subscriptions.push(this.firebase.subscribeTo(`works/${this.chat().document_type}-` + this.chat().document_id, (data) => {
      console.log('[FIREBASEDB] Works changed', data);
      if (data) {
        this.cdr.markForCheck();
        for(const workId in data){
          const work = data[workId];
          const index = this.works.findIndex((w) => w.id === parseInt(workId));
          if (index !== -1) {
            this.works[index] = { ...work };
          }
          else {
            this.works.push(work);
          }
        }
        this.getOwnWorks();
        this.cdr.detectChanges();
      }
    },
      this.destroyRef
    ));
    this.subscriptions.push(this.firebase.subscribeTo(`comments/${this.chat().document_type}-` + this.chat().document_id, (data) => {
      if (data) {
        console.log('[FIREBASEDB] Message removed', data);
        
        this.cdr.markForCheck();
        const message = this.messages.find((msg) => msg.id === data.id);
        if(message){
          this.removeMessageData(message)
          this.indexedDB.write('messages', {
            ...message,
          });
        }
      }
    }, this.destroyRef, onChildRemoved, true));

    this.subscriptions.push(this.firebase.subscribeTo(`comments/${this.chat().document_type}-` + this.chat().document_id, (data) => {
      if (data) {
        console.log('[FIREBASEDB] Message changed', data);
        if(!data.pictures){
          data.pictures = [];
        }
        this.cdr.markForCheck();
        const message = this.messages.find((msg) => msg.id === data.id);
        if(message){
          const index = this.messages.indexOf(message);
          if (index !== -1) {
            this.messages[index] = { ...this.messages[index], ...data };
          }
          this.indexedDB.write('messages', {
            ...this.messages[index],
          });
        }

      }
    }, this.destroyRef, onChildChanged, true));


    
    this.subscriptions.push(this.firebase.subscribeTo(`documents/${this.chat().document_type}-` + this.chat().document_id, (data) => {
      console.log('[FIREBASEDB] Document changed', data);
      if (data) {
        this.document = data;
        this.getCustomWorks();
      }
    },
      this.destroyRef
    ));
  }

  getNextPage() {
    
    this.page++;
    this.getPage()
  }

  getPage(page?){
    const total = this.allMessages.length;
    if(!page){
      page = this.page;
    }
    const end = total - this.messagesPerPage * page;
    const start = Math.max(0, end - this.messagesPerPage);
    const newMessages = this.allMessages.slice(start, end);
    this.messages = [...newMessages, ...this.messages];
    this.cdr.detectChanges();
    this.scrollToBottom();
  }

  
  onScroll(event: any) {
    // Detecta si el scroll está en la parte superior (cercano a 0)
    
    if (event.target.scrollTop <= 100 && this.page+1 < Math.ceil(this.allMessages.length / this.messagesPerPage)) {
      this.getNextPage();
    }
    if(event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight >= 300){
      this.readingOldMessages.set(true);
    }else if(
      this.readingOldMessages()
    ){
      this.readingOldMessages.set(false);
      this.read();
    }
    
  }


  @HostListener('window:focus', ['$event'])
  onFocus(event: FocusEvent) {
    this.getChatComments(false);
  }

  getCustomWorks() {
    if (!this.chat()?.document_type || this.chat()?.document_type === 'OpenAi::Thread') {
      this.customWorks = [];
      return;
    }

    this.workService.requiredWorks(this.chat().document_type, this.chat().document_id).pipe(take(1)).subscribe((works:any) => {
      this.customWorks = works.body
      this.cdr.detectChanges();
    });
  }

  getOwnWorks(){
    this.ownWorks = this.works.filter(
      work => work.user_id === this.user.id
      && work.completed_at === null
    );
    if(this.ownWorks.length > 0){
      this.currentWork = this.ownWorks[this.ownWorks.length - 1];
    }
    this.work = null;
    this.fullScreen.set(false);
    this.cdr.detectChanges();
  }

  selectWork(work) {
    this.currentWork = work;
    this.cdr.detectChanges();
    this.scrollToBottom(true);
  }

  addCustomWork(work){
    this.workService.requestWork({
      document_id: this.chat().document_id,
      document_type: this.chat().document_type,
      work_id: work.id,
      skip_notifications: true
    }).pipe(take(1)).subscribe((data) => {
      
    });
  }

  scrollToBottom(instant=false, force=false): void {
    try {
      if(this.messagesContainer && (!this.readingOldMessages() || force)){
        if(instant) {
          this.messagesContainer.nativeElement.scrollTop = this.messagesContainer.nativeElement.scrollHeight;
          this.readingOldMessages.set(false);
        } else {
          this.messagesContainer.nativeElement.scrollTo({
            top: this.messagesContainer.nativeElement.scrollHeight,
            behavior: 'smooth'
          })
        }
      }
    } catch (err) {
      console.error('Error al hacer scroll', err);
    }
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.shiftKey) {
      return;
    }
    event.preventDefault();
    this.sendMessage();
  }

  formatComment(comment,messages) {
    const value = {
      ...comment,
      isOwn: comment.author_id === this.user.id && comment.author_type === 'User',
      isSystem: comment.author_type === 'Commentator::System',
      isKogu: comment.author_type === 'Commentator::Kogu',
    }
    if(comment.target_id && comment.target_type === 'Comment') {
      const findReply = messages.find((message) => message.id === comment.target_id && comment.target_type === 'Comment');
      if (findReply) {
        value.reply = this.formatComment(findReply,messages);
      }
    }
    return value;
  }

  read(){
    const lastMessage = this.messages[this.messages.length - 1];
    if(lastMessage && lastMessage.updated_at && lastMessage.updated_at >= this.chat()?.readed_at){
      if(this.chat() && !this.readingOldMessages()){
        this.chatService.readChat(this.chat().id,lastMessage.id).subscribe((data) => {
          if(this.chat()){
            this.chat().readed_at = data.readed_at;
          }
        });
      }
    }else if(lastMessage){
      this.chat().readed_at = lastMessage.created_at;
    }
  }
  
  sendMessage() {
    if(!this.agentWorking()){
      this.tempText = (this.inputText()).trim();
      this.inputText.set('');
      const isEditingEvent = !!this.event?.message_id;
      
      if (this.tempText !== '' || this.openBudgetForm() || this.event || this.imagePreviews.length > 0) {
        let message:any = {
          author: {
            id: this.user.id,
            name: this.user.name,
            picture: this.user.picture,
          },
          comment: this.tempText,
          created_at: new Date(),
          updated_at: new Date(),
          isOwn: true,
          id: isEditingEvent ? this.event.message_id : null,
          user_id: this.user.id,
          upload: this.imagePreviews,
          pictures: []
        }
        if(this.reply){
          message.target_id = parseInt(this.reply.id);
          message.target_type = 'Comment';
          message.reply = { ...this.reply };
          this.reply = null;
        }
        if(this.event){
          message.calendar_event = {...this.event};
          this.event = null;
          this.eventForm.reset();
        }
        if(this.openBudgetForm()) {
          message.document_type = 'Budget';
          message.document_attributes = this.budgetForm.value;
          this.closeBudgetForm();
        }
        if(this.currentWork){
          message.work_instance_id = this.currentWork.id;
          message.work_instance = this.currentWork;
        }
        if (isEditingEvent) {
          // Actualiza el evento en el servidor
          this.updateMessage(message);
        } else {
          // Crea un nuevo mensaje
          this.messages.push(message);
          this.allMessages.push(message);
    
          if (this.imagePreviews.length == 0) {
            const lastMessage = this.messages[this.messages.length - 1];
            this.createMessage(lastMessage).subscribe((message: any) => {
              lastMessage.id = message.id;
              lastMessage.created_at = message.created_at;
              lastMessage.updated_at = message.updated_at;
              this.cdr.detectChanges();
            });
          } else {
            this.uploadingPhotos.set(true);
          }
        }
        this.cdr.detectChanges();
        this.scrollToBottom();
      }
    }
  }
  createMessage(message) {
    return new Observable((observer) => {
      if(this.isThread){
        this.agentWorking.set(true);
        this.chatSubscribe();
      }
      this.chatService.comment(this.chat().id, message).subscribe((data) => {
        message.id = data.id;
        message.document_id = data.document_id;
        message.document = data.document;
        message.created_at = data.created_at;
        this.chat().readed_at = data.created_at;
        this.cdr.detectChanges();
        observer.next(data);
      }, (error) => {
        console.error('Error al enviar el mensaje', error);
        if(this.isThread){
          this.agentWorking.set(false);
        }
        this.cdr.detectChanges();
        observer.error(error);
      });
    });
  }
  updateMessage(message: any) {
    // Implementa la lógica para actualizar el mensaje en el servidor
    const index = this.messages.findIndex(msg => msg.id === message.id);
    if (index !== -1) {
      this.messages[index] = { ...message };
    }
    this.chatService.updateComment(this.chat().id, message.id, message).subscribe((data) => {
      this.cdr.markForCheck();
      const index = this.messages.findIndex(msg => msg.id === message.id);
      if (index !== -1) {
        this.messages[index] = { ...message, ...data };
      }
      this.cdr.detectChanges();
    }, (error) => {
      console.error('Error al actualizar el mensaje', error);
    });
  }

  addPhotos(message, photos) {
    const fphotos = photos.filter((photo) => !photo.id);
    if (fphotos && fphotos.length > 0 && this.uploadingPhotos()) {
      this.imagePreviews = [];
      this.uploadingPhotos.set(false);
      this.createMessage(message).subscribe({
        error: (error) => {
          console.error('Error al enviar el mensaje', error);
          this.messages.pop();
          
          this.cdr.detectChanges();
        },
        next: (data:any) => {
          message.pictures = data.pictures;
          this.cdr.detectChanges();
        }
      });
    }
  }

  takePicture(){
    const dialogRef = this.dialog.open(
      CameraComponent,
      { width: '80%', height: '80%' }
    );

    dialogRef.componentInstance.photoCaptured.subscribe((file: any) => {
      file.progress = 0;
      file.uploading = true;
      file.uploaded = false;
      file.error = false;
      file.blob = URL.createObjectURL(file);
      file.url = file.thumb || file.blob;

      this.imagePreviews.push({
        file: file,
        url: file.url,
        name: file.name
      });
      this.scrollToBottom();
      this.cdr.detectChanges();

    });
  }

  goToDocument() {
    if (this.chat() && this.chat().document_id) {
      
      const type = this.chat().super_type.split("::")[0].replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()+"s";
      
      this.router.navigate(['main',type, this.chat().document_id]);
    }
  }

  downloadDocument(message: any) {
    this.pdfService.getBudget(message.document_id, `Presupuesto_${message.document.correlative_id}`, 'inline');
  }

  goToWork(work) {
    if (work && work.id) {
      this.router.navigate(['main','work', work.id]);
    }
  }
  goBack() {
    this.chat.set(null);
    this.cdr.detectChanges();
  }

  toggleWork(){
    if (this.work) {
      this.work = null;
      this.fullScreen.set(false);
    } else {
      this.work = {
        ...this.currentWork
      }
      this.fullScreen.set(true);
    }
    this.scrollToBottom(true);
    this.cdr.detectChanges();
  }

  calculateDuration(startedAt: Date): string {
    this.cdr.markForCheck();
    const now = new Date();
    const start = new Date(startedAt);
    
    const msInMinute = 1000 * 60;
    const msInHour = msInMinute * 60;
    const msInDay = msInHour * 24;
  
    const durationInMs = now.getTime() - start.getTime();
    const durationInDays = Math.floor(durationInMs / msInDay);
    const durationInHours = Math.floor((durationInMs % msInDay) / msInHour);
    const durationInMinutes = Math.floor((durationInMs % msInHour) / msInMinute);
  
    if (durationInDays > 0) {
        return `${durationInDays} día(s)`;
    } else if (durationInHours > 0) {
        return `${durationInHours} hora(s)`;
    } else {
        return `${durationInMinutes} minuto(s)`;
    }
  }
  
  addImages(){
    this.fileInput.nativeElement.setAttribute('accept', 'image/*');
    this.fileInput.nativeElement.click();
  }

  addEvent(){
    this.event = {
      id: null,
      start_date: moment(),
      duration: 1,
    }
  }

  editEvent(message: any): void {
    if (message.calendar_event) {
      this.event = {
        ...message.calendar_event,
        message_id: message.id,
      };
      // Establece los valores actuales en el formulario
      this.eventForm.setValue({
        name: message.calendar_event.name || '',
        start_date: message.calendar_event.start_date || new Date(),
        duration: message.calendar_event.duration || 1,
        id: message.calendar_event.id || null
      });

      this.inputText.set(message.comment);
  
      // Marca el evento actual
      
  
      // Detectar cambios y desplazar hasta abajo
      this.cdr.detectChanges();
      this.scrollToBottom();
    }
  }

  endEvent(message: any): void {
    console.log('End event', message);
  }

  closeBudgetForm() {
    this.budgetForm = this.fb.group({
      document_id: this.fb.control<number | null>(this.chat().document_id),
      document_type: this.fb.control<string | null>(this.chat().document_type),
      inventory_actions: this.fb.array([]),
    });
    this.openBudgetForm.set(false);
    this.cdr.detectChanges();
  }
  
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const files = Array.from(input.files);
      const photos = files.filter((file) => file.type.startsWith('image/')).map((file) => {
        return {
          file: file,
          url: URL.createObjectURL(file),
          name: file.name
        };
      });
      this.imagePreviews = photos;
      this.scrollToBottom();
      this.cdr.detectChanges();
    }
  }
  removeImage(index: number): void {
    this.imagePreviews.splice(index, 1);
  }

  deleteMessage(message: any): void {
    const index = this.messages.indexOf(message);
    const meesage = this.messages[index];
    if (this.canDelete(message)) {
      this.removeMessageData(message);
      this.chatService.deleteComment(message.id).subscribe(() => {
        this.cdr.detectChanges();
      });
    }
  }

  removeMessageData(message: any): void {
    message.deleted_at = moment().toISOString();
    message.comment = ''
    message.pictures = [];
    message.calendar_event = null;
    message.reply = null;
  }

  canDelete(message: any): boolean {
    const index = this.messages.indexOf(message);
    const now = new Date();
    const messageCreationTime = new Date(message.created_at);
    const timeDifference = (now.getTime() - messageCreationTime.getTime()) / 1000 / 60;
    
    if (timeDifference > 5) {
      return false;
    }
    return true;
  }

  replyToMessage(message: any): void {
    this.reply = message;
    this.chatInput.focus();
    this.scrollToBottom();
  }

  cancelReply(): void {
    this.reply = null;
    this.scrollToBottom();
    this.cdr.detectChanges();
  }

  cancelEvent(){
    this.event = null;
    this.cdr.detectChanges();
  }

  copyMessage(message: any): void {
    const textToCopy = message.comment;
    navigator.clipboard.writeText(textToCopy).then(() => {
      console.log('Texto copiado al portapapeles');
    }).catch((error) => {
      console.error('Error al copiar el texto: ', error);
    });
  }

  selectThread(thread: any): void {
    this.isThread = true;
    this.chatService.get('agent', thread.id).subscribe((response) => {
      this.loading.set(false);
      this.chat.set(response);
      this.chatSubscribe();
      this.getChatComments();
    }), (error) => {
      this.loading.set(false);
      console.error('Error fetching IA chat', error);
    }
    this.cdr.detectChanges();
  }
  createThread(): void {
    this.isThread = true;
    
    if(this.messages && this.messages.length > 0){
      this.loading.set(true);
      const firstMessage = this.messages[0];
      const thread = {
        ...this.chat(),
        first_comment: firstMessage.comment,
      }
      this.threads.push(thread);
      this.chatService.get('agent').subscribe((response) => {
        this.loading.set(false);
        this.chat.set(response);
        this.chatSubscribe();
        this.getChatComments();
        this.cdr.detectChanges();
        
      }, (error) => {
        this.loading.set(false);
        console.error('Error fetching IA chat', error);
      }
      );
    }
  }

  onClickWhatsapp() {
    this.snackBar.open(
      'Esta función no está incluída en su plan actual. Por favor, contacte al administrador.',
      'Cerrar',
      {
        duration: 5000,
        panelClass: 'snackbar-info',
      }
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => {
      if (sub.unsubscribe) {
        sub.unsubscribe();
      }
    });
    this.subscription?.unsubscribe();
    if(this.threadSub){
      this.threadSub.unsubscribe();
    }
  }
}
